import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatIconModule} from '@angular/material/icon';
import {HelpContentModule} from '../../common/help-content/help-content.module';
import {HelpNavBackModule} from '../../common/help-nav-back/help-nav-back.module';
import {HelpSelectMicrohoneContentComponent} from './help-select-microhone-content/help-select-microhone-content.component';
import {HelpSelectMicrophoneComponent} from './help-select-microphone.component';

@NgModule({
  declarations: [
    HelpSelectMicrophoneComponent,
    HelpSelectMicrohoneContentComponent
  ],
  exports: [HelpSelectMicrophoneComponent, HelpSelectMicrohoneContentComponent],
  imports: [
    CommonModule,
    HelpContentModule,
    HelpNavBackModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class HelpSelectMicrophoneModule {}
